import styles from '../TopUpStatusAlertBox.module.css';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';

export const TopUpEligibleAlert = () => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            iconName="userCheck"
            className={styles.blueAlertBox}
            iconClassName={styles.blueAlertBoxIcon}
            description={
                <>
                    <strong>
                        Great news, you can now request more funds -
                    </strong>{' '}
                    you can choose whether to go ahead once you have received an
                    offer
                </>
            }
        />
    );
};
